/* eslint-disable no-unused-vars */

import {
  Card,
  IconButton,
  LinearProgress,
  Menu,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@material-ui/core';
import React, { FC, memo, useCallback, useRef, useState } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Pagination } from '@material-ui/lab';
import { useRmaInventory } from 'src/hooks/rma-inventory/use-rma-inventory';
import { AlternatingColorTableRow } from 'src/components';
import { formatingDate } from 'src/utils';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { cloneDeep } from 'lodash';
import { AnchorEl } from 'src/types';

const Component: FC = () => {
  const {
    rmaInventoryItems,
    meta,
    isLoading,

    onChangeFilters,
    createCreditNote,
    createTransaction
  } = useRmaInventory();

  const [anchorEls, setAnchorEls] = useState<AnchorEl>({});

  const openActionMenu = (event: any, menuId?: number) => {
    if (!menuId) return;
    event.stopPropagation();
    const clonedAnchorEls: any = cloneDeep(anchorEls);
    clonedAnchorEls[menuId] = event.currentTarget;
    setAnchorEls(clonedAnchorEls);
  };

  const handleActionClose = () => {
    setAnchorEls({});
  };

  const onChangePage = useCallback(
    (e: any, value: number) => {
      onChangeFilters({ page: value });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const onHandleCreateTransaction = async (id: number) => {
    const response = await createTransaction(id);

    if (response?.success) {
      const message = response?.originalData?.message;
      const match = message?.match(/PCW-\d+/) || '';

      if (match) {
        const transactionCode = match[0];
        const url = `/app/transaction/${transactionCode}`;

        window.open(url, '_blank');
      } else {
        console.error('Transaction code not found in message');
      }
    }
  };

  const StyledTableCell: FC<{ label: string }> = ({ label }) => (
    <TableCell>
      <div style={{ display: 'flex', justifyContent: 'center' }}>{label}</div>
    </TableCell>
  );

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'end', margin: '.5em 0' }}>
        <Pagination
          disabled={isLoading}
          page={meta?.current_page || 1}
          onChange={onChangePage}
          count={meta?.last_page || 1}
        />
      </div>
      <PerfectScrollbar>
        <Card style={{ minWidth: '2900px', width: '100%' }}>
          {isLoading ? <LinearProgress /> : null}
          <Table>
            <TableHead>
              <TableRow>
                {/* intended different for style purposes */}
                <TableCell>CRM Status</TableCell>
                <StyledTableCell label="RMA Inventory Status" />
                <StyledTableCell label="Status Change" />
                <StyledTableCell label="Location" />
                <StyledTableCell label="Transaction No." />
                <StyledTableCell label="Product Name" />
                <StyledTableCell label="Serial No." />
                <StyledTableCell label="Supplier" />
                <StyledTableCell label="Customer Name" />
                <StyledTableCell label="Date sold" />
                <StyledTableCell label="Replace with Item" />
                <StyledTableCell label="Replace with Serial" />
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rmaInventoryItems?.[0]
                ? rmaInventoryItems?.map((item, ind) => (
                    <AlternatingColorTableRow key={ind}>
                      {/* intended different for style purposes */}
                      <TableCell>{item.rma_crm_status ?? ''}</TableCell>
                      <StyledTableCell
                        label={item.rma_inventory_status ?? ''}
                      />
                      <StyledTableCell
                        label={item.status_change_inventory ?? ''}
                      />
                      <StyledTableCell label={item.location ?? ''} />
                      <StyledTableCell label={item.transaction_no ?? ''} />
                      <StyledTableCell label={item.product_name ?? ''} />
                      <StyledTableCell label={item.serial_no ?? ''} />
                      <StyledTableCell label={item.supplier ?? ''} />
                      <StyledTableCell label={item.customer_name ?? ''} />
                      <StyledTableCell
                        label={
                          item.date_sold
                            ? String(formatingDate(item.date_sold))
                            : ''
                        }
                      />
                      <StyledTableCell
                        label={item?.replace_with_item?.name ?? ''}
                      />
                      <StyledTableCell label={item.replace_serial ?? ''} />

                      <TableCell>
                        <IconButton
                          aria-label="more"
                          aria-controls="long-menu"
                          aria-haspopup="true"
                          onClick={(e) => openActionMenu(e, item?.id)}
                        >
                          <MoreVertIcon />
                        </IconButton>
                        <Menu
                          id={item.id.toString()}
                          anchorEl={anchorEls[item.id]}
                          keepMounted
                          open={!!anchorEls[item.id]}
                          onClose={handleActionClose}
                        >
                          <MenuItem onClick={() => createCreditNote(item.id)}>
                            Create Credit Note
                          </MenuItem>
                          <MenuItem
                            onClick={() => onHandleCreateTransaction(item.id)}
                          >
                            Create Transaction
                          </MenuItem>
                        </Menu>
                      </TableCell>
                    </AlternatingColorTableRow>
                  ))
                : null}
            </TableBody>
          </Table>
        </Card>
      </PerfectScrollbar>
      <div style={{ display: 'flex', justifyContent: 'end', margin: '.5em 0' }}>
        <Pagination
          disabled={isLoading}
          page={meta?.current_page || 1}
          onChange={onChangePage}
          count={meta?.last_page || 1}
        />
      </div>
    </>
  );
};

export const RmaInventoryTable = memo(Component);
